import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  cart: [],
};

const cartSlice = createSlice({
  name: "cartReducer",
  initialState,
  reducers: {
    addItemToCart(state, action) {
      const newItem = action.payload;
      // if we already have this item
      if (state.cart?.some((e) => e?._id === newItem._id)) {
        if (newItem?.quantity < newItem?.stock) {
          const cartCopy = [...state.cart];
          const indexInCart = cartCopy?.findIndex(
            (e) => e?._id === newItem?._id
          );
          cartCopy[indexInCart].quantity =
            parseInt(cartCopy[indexInCart].quantity) + 1;
          state.cart = cartCopy;
        } else {
          state = state;
          return toast.error("Max stock quantity reached.");
        }
      }
      // if we dont have this item
      else {
        if (newItem?.stock > 1) {
          state.cart.push({ ...newItem, quantity: 1 });
          toast.success("Item successfully added to cart.");
        } else {
          state = state;
          return toast.error("This card is not in stock.");
        }
      }
    },
    removeItemFromCart(state, action) {
      const itemToRemove = action.payload;

      const cartCopy = [...state.cart];
      const indexInCart = cartCopy?.findIndex(
        (e) => e?._id === itemToRemove?._id
      );
      // if item quantity > 1
      if (cartCopy[indexInCart].quantity > 1) {
        cartCopy[indexInCart].quantity =
          parseInt(cartCopy[indexInCart].quantity) - 1;
        state.cart = cartCopy;
      }
      //   if we have only 1 quantity
      else {
        cartCopy.splice(indexInCart, 1);
        state.cart = cartCopy;
        toast.success("Item successfully removed from cart.");
      }
    },
    clearCart(state) {
      state.cart = [];
    },
  },
});

export const { addItemToCart, removeItemFromCart, clearCart } =
  cartSlice.actions;

export default cartSlice.reducer;
